<template>
  <div class="mt-2">
    <v-row class="sticky top-0 z3 mt-2" style="height: 10px;">
      <v-col cols="2" class="d-flex justify-center white-bg pa-0">
        <div>
          <v-chip
            v-if="hourSort"
            class="ma-2"
            close
            @click:close="hourSort = null"
          >
            Trier par: {{ hourSort }}h
          </v-chip>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="2 py-0">
        <ContentTypeValueList class="px-1" :content-types="contentTypeValues" />
      </v-col>
      <v-col cols="10">
        <div :id="`contentTypePlanner-${tabKey}`" v-dragscroll class="full-height overflow-x-auto overflow-y-hidden all-scroll no-scroll" @dragscrollmove="syncScrollWith('mainPlanner')">
          <HoursList :id="`hourList-${tabKey}`" class="ml-2" :show-sort="true" :hour-sort="hourSort" @sortHour="sortByHour" />
          <div>
            <ContentTimeTable v-if="contentTypeValues" :content-type-values="contentTypeValues" :content="tabKey" />
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { ref, computed } from '@vue/composition-api';
import ContentTimeTable from './ContentTimeTable.vue';
import ContentTypeValueList from './ContentTypeValueList.vue';
import HoursList from '../HoursList.vue';
import { rowPerContentType, sortPlannerContentByHour, syncScrollWith } from '@/helpers/utils';
import { filterContentType } from '@/helpers/search';

export default {
  name: 'CalendarContentType',
  components: {
    ContentTimeTable,
    ContentTypeValueList,
    HoursList
  },
  props: {
    tabKey: {
      type: String,
      default: ''
    }
  },
  setup (props) {
    const crmUrl = `${process.env.VUE_APP_CRM_URL}?fromPegase=true`;
    const isCustomerTab = computed(() => props.tabKey === 'customer');
    const hourSort = ref(null);

    const contentTypeValues = computed(() => {
      const filteredTypes = filterContentType(props.tabKey);
      rowPerContentType(filteredTypes);

      let sortedSessions = [];
      if (hourSort.value) {
        sortedSessions = sortPlannerContentByHour(filteredTypes, hourSort.value);
      }
      return sortedSessions.length ? sortedSessions : filteredTypes;
    });

    const sortByHour = hour => {
      hourSort.value = hour;
    };

    return { hourSort, sortByHour, isCustomerTab, crmUrl, contentTypeValues, syncScrollWith };
  }
};
</script>
